import { defineStore } from 'pinia';
import useAjax from '@/functions/use_ajax';

const ajax = useAjax({ useWithoutSetup: true });

export const useReportsStore = defineStore({
  id: 'reports',
  state: () => ({
    loading: false,
    reports: [],
    fetchReportsError: false,
    reportPolicies: null,
  }),
  actions: {
    /**
     * Fetch reports
     * @param {string} endpoint
     */
    async fetchReports(endpoint) {
      this.reports = [];
      this.loading = true;
      this.fetchReportsError = false;

      let { ok, data } = await ajax(endpoint);

      if (ok) {
        this.reports = data;
      } else {
        this.fetchReportsError = true;
      }

      this.loading = false;
    },

    /**
     * Delete report
     * @param {string} id - report id
     * @param {string} endpoint - DELETE endpoint
     */
    async deleteReport(id, endpoint) {
      let { ok } = await ajax(endpoint, { method: 'DELETE' });

      if (ok) {
        this.reports = this.reports.filter((report) => report.id !== id);
      }
    },

    /**
     * Fetch report policies
     * @param {string} endpoint
     */
     async fetchReportPolicies(endpoint) {
      this.reportPolicies = null;

      let { ok, data } = await ajax(endpoint);

      if (ok) {
        this.reportPolicies = data;
      }
    },
  },
});
